export const USER_ROLES = {
	INTERNAL: 'INTERNAL',
	EXTERNAL: 'EXTERNAL',
	BROKER: 'BROKER',
	CARRIER: 'CARRIER',
	SHIPPER: 'SHIPPER',
	OWNER: 'OWNER',
	ADMIN: 'ADMIN',
	EMAIL_EDITOR: 'EMAIL_EDITOR',
};
